import { render } from "./Widget2.vue?vue&type=template&id=245db72f"
import script from "./Widget2.vue?vue&type=script&lang=ts"
export * from "./Widget2.vue?vue&type=script&lang=ts"
script.render = render

export default script